export function mapShippingFormToDto(form) {
    return {
        name: form.name,
        city: form.city,
        countryUuid: form.countryUuid,
        postcode: form.postcode,
        street: form.street,
        buildingNumber: form.buildingNumber,
        buildingName: form.buildingName,
        unitNumber: form.unitNumber,
    };
}
export function mapUserAddressToCheckoutAddress(userAddress) {
    return {
        name: userAddress.name ?? null,
        street: userAddress.street ?? null,
        postcode: userAddress.postcode ?? null,
        buildingNumber: userAddress.buildingNumber ?? null,
        buildingName: userAddress.buildingName ?? null,
        unitNumber: userAddress.unitNumber ?? null,
        id: userAddress.id ?? 0,
        countryUuid: userAddress.countryUuid ? userAddress.countryUuid : null,
        city: userAddress.city ?? null,
        isDefault: false,
    };
}
